import { defineComponent as _defineComponent } from 'vue'
import { Icons } from '@/font-awesome';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';


export default /*@__PURE__*/_defineComponent({
  __name: 'UsersCounter',
  props: {
    count: { type: Number, required: true },
    isReverse: { type: Boolean, required: false },
    hasSize: { type: Number, required: false },
    color: { type: String, required: false },
    hasStroke: { type: Boolean, required: false }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

function getColor() {
  switch (props.color) {
    case 'pink': return 'var(--option-color-pink-dark, #E02867)';
    default: return 'var(--options-color-red-base, #F64664)';
  }
}


const __returned__ = { props, getColor, get Icons() { return Icons }, get FontAwesomeIcon() { return FontAwesomeIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})